
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/x/api/charts/heatmap-tooltip-content",
      function () {
        return require("private-next-pages/x/api/charts/heatmap-tooltip-content.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/x/api/charts/heatmap-tooltip-content"])
      });
    }
  